import { useContext } from 'react';
import EarlyAccessContext from '../context/EarlyAccessContext';

const CallToAction = () => {
  const { setIsOpen } = useContext(EarlyAccessContext);
  return (
    <section className="section section--cta" id="cta">
      <div className="cta">
        <h2>Join the Founding Families list.</h2>
        <p>
          Early access opens soon for UK parents of children aged 5 - 8. Be the first to give your child a game that's genuinely engaging and educational.
        </p>
        <p>No spam. Just one email when we launch.</p>
        <div className="hero__actions">
          <button className="btn btn--red" onClick={() => setIsOpen(true)}>Join the early access list</button>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
